import { AavoObjectRef } from "src/api/generated/common/aavoObject/aavoObjectRef.ts";
import { AavoObjectType } from "src/api/generated/common/aavoObject/aavoObjectType.ts";
import { TenantConfig } from "src/tenantCustomizations/TenantCustomizations.ts";

const DOCUMENT_CUSTOMER_SHARING_OBJECT_TYPES: readonly AavoObjectType[] = [
	"CUSTOMER_ORDER",
	"CUSTOMER_ORDER_LINE",
	"CUSTOMER_ORDER_OFFER",
	"CUSTOMER_ORDER_OFFER_LINE",
];

/**
 * The "shared with customer" flag is shown only for selected tenants and only when every viewed object
 * is a customer order, customer order line, customer offer or customer offer line.
 */
export function isDocumentCustomerSharingVisible(tenantConfig: TenantConfig, objectRefs: AavoObjectRef[]): boolean {
	if (!tenantConfig.erp.documentCustomerSharingEnabled) return false;
	if (objectRefs.length === 0) return false;
	return objectRefs.every((objectRef) => DOCUMENT_CUSTOMER_SHARING_OBJECT_TYPES.includes(objectRef.objectType));
}
